"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.list.title': '教程',
    'tutorial.list.empty.title': '未找到教程',
    'tutorial.list.empty.message': '创建您的第一个教程，开始互动学习体验。',
    'tutorial.expired': '已过期',
    'tutorial.draft': '草稿',
};
